// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import ScrollSmooth from './modules/Animation/scrollLenis'
import AnimationElements  from './modules/Animation/enterElements'
import Footer from './modules/Layouts/footer'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import forms from './modules/Forms/forms'
import SocialFixed from './modules/Components/socialFixed'
import Preloader from './modules/Animation/preloader'

// Initialize preloader
Preloader()

//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
forms();
// Layout
Footer()
SocialFixed()

// Animations
//ScrollSmooth()
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()

// Utils
//AnchorLinks()
